import { AlertDialog, useDialog as useDaxDialog } from '@global-dax-ad-platform/dax-components';
import { DeleteIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { Typography, IconButton } from '@global-engineering-shared/gweb-material-ui';

import { useRefresh } from 'context/RefreshProvider/RefreshProvider';
import { useSelectedEntitiesContext } from 'context/SelectedEntities/SelectedEntitiesProvider';
import useStyles from 'features/Drafts/components/RemoveButton/RemoveButton.styles';
import useFetchData from 'hooks/useFetchData';
import { DRAFTS_API_URL, DRAFTS_PAGE_REMOVE_DIALOG_ID } from 'utils/defaults';
import { DraftStatusByTable } from 'utils/statuses';

export interface IRemoveButtonProps {
  status: DraftStatusByTable;
}

const RemoveButton = ({ status }: IRemoveButtonProps) => {
  const classes = useStyles();

  const { selectedEntityIds, areEntitiesSelected, resetSelectedEntities } =
    useSelectedEntitiesContext();
  const { deleteData } = useFetchData();
  const { triggerRefresh } = useRefresh();
  const { openDialog: openDaxDialog } = useDaxDialog();

  const removeSelected = async () => {
    await deleteData(`${DRAFTS_API_URL}?spaceIds=${selectedEntityIds().join(',')}`);
    resetSelectedEntities();
    triggerRefresh();
    // TODO: handle action response - eg. Navigate to Drafts, BulkActionResponse Page
  };

  const EntityAmount = selectedEntityIds().length;
  return (
    <>
      {areEntitiesSelected && (
        <>
          <AlertDialog
            dialogId={DRAFTS_PAGE_REMOVE_DIALOG_ID + status}
            content={{
              title: 'Remove Drafts',
              main: (
                <>
                  <Typography color="textPrimary" variant="body2">
                    Click continue to <strong>Remove</strong> {EntityAmount} Draft
                    {EntityAmount > 1 && 's'}
                  </Typography>
                </>
              ),
            }}
            action={{
              label: 'Continue',
              onClick: removeSelected,
            }}
          />
          <IconButton
            className={classes.container}
            onClick={() => openDaxDialog(DRAFTS_PAGE_REMOVE_DIALOG_ID + status)}
          >
            <DeleteIcon className={classes.icon} />
            <Typography variant="button" fontWeight={500} className={classes.text}>
              Remove Selected
            </Typography>
          </IconButton>
        </>
      )}
    </>
  );
};
export default RemoveButton;
